import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import EquipSingleView from './EquipSingleView';
import { setBackButtonLabel, setBackButtonLinkAction } from '../../../redux/actions/ui';
import { getSelectedEquipmentWithDetails } from '../../../redux/selectors/equipment';
import { getEquipTypeName } from '../../../redux/selectors/equiptypes';
import { getBuildingName } from '../../../redux/selectors/buildings';
import { updateCurrentPath, getSearchParams } from '../../../utils/url';
import EquipmentLoader from '../../loaders/EquipmentLoader';
import EquipTypeLoader from '../../loaders/EquipTypeLoader';
import PointTypeLoader from '../../loaders/PointTypeLoader';
import LabelsLoader from '../../loaders/LabelsLoader';
import TagsLoader from '../../loaders/TagsLoader';
import MeasurementsLoader from '../../loaders/MeasurementsLoader';
import UnitsLoader from '../../loaders/UnitsLoader';

const mapStateToProps = (state, ownProps) => ({
  equipment: getSelectedEquipmentWithDetails(state, ownProps.location.search),
  equipType: getEquipTypeName(state, ownProps.etid),
  buildingName: getBuildingName(state, ownProps.bid),
});

const mapDispatchToProps = (dispatch) => ({
  setBackButtonLabel: (label) => dispatch(setBackButtonLabel(label)),
  setBackButtonLink: (link) => dispatch(setBackButtonLinkAction(link)),
});

class EquipSingleContainer extends PureComponent {
  componentDidMount() {
    this.props.setBackButtonLabel('< BACK TO EQUIPMENT VIEW');
    const backLink = `/explore/buildings/${encodeURIComponent(
      this.props.buildingName
    )}/${encodeURIComponent(this.props.equipType)}`;
    // 'bid', 'etid', 'floorPhys', 'floorServed', 'inclChild'
    const searchString = `?bid=${this.props.bid}&etid=${this.props.etid}&floorPhys=${this.props.floorPhys}&floorServed=${this.props.floorServed}&inclChild=${this.props.inclChild}`;
    this.props.setBackButtonLink(`${backLink}${searchString}`);
  }

  componentWillUnmount() {
    this.props.setBackButtonLabel(null);
  }

  render() {
    const { bid, equipment, location, navigate } = this.props;
    const params = getSearchParams(location.search);
    const tabVal = params.tab;
    return (
      <>
        <EquipmentLoader buildingId={bid} />
        <EquipTypeLoader />
        <PointTypeLoader />
        <LabelsLoader />
        <TagsLoader />
        <MeasurementsLoader />
        <UnitsLoader />
        <EquipSingleView
          equipment={equipment}
          tab={tabVal}
          handleTabChange={(tab) => updateCurrentPath(navigate, { tab })}
        />
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EquipSingleContainer);
